export default __webpack_public_path__ + "i18n/translation-de.ad11c64b.json";